import { noop } from 'shared/entities/common/utils';

import { createLerpScroll } from './lerpScroll';
import { ScrollZone } from './types';
import type { ScrollController } from './types';
import { createWheelHandler } from './wheelScroll';

const DEFAULT_SCROLLBAR_ZONE_HEIGHT = 24;

export type BindScrollControllerOptions = {
  smoothFactor: number;
  wheelScroll?: boolean;
  zone?: ScrollZone;
  scrollbarZoneHeight?: number;
};

export type ScrollControllerAttach = {
  controller: ScrollController;
  cancelAnimation: () => void;
  syncTargetFromContainer: () => void;
  handleWheel: (evt: WheelEvent) => void;
};

export const bindScrollController = (
  container: HTMLElement,
  {
    smoothFactor,
    wheelScroll = false,
    zone = ScrollZone.full,
    scrollbarZoneHeight = DEFAULT_SCROLLBAR_ZONE_HEIGHT
  }: BindScrollControllerOptions
): ScrollControllerAttach => {
  const lerp = createLerpScroll(container, smoothFactor);

  const handleWheel = wheelScroll
    ? createWheelHandler(container, {
        zone,
        scrollbarZoneHeight,
        lerp
      })
    : noop;

  return {
    controller: lerp.controller,
    cancelAnimation: lerp.cancelAnimation,
    syncTargetFromContainer: lerp.syncTargetFromContainer,
    handleWheel
  };
};
